var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ApolloClient, ApolloLink, gql, HttpLink, InMemoryCache, } from '@apollo/client/core';
import { Auth } from '@aws-amplify/auth';
import { AUTH_TYPE, createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import getConfig from '../config';
import StandingStore from '../standingStore';
import { splitPackageByAddressId as splitPackageByAddressIdMutation } from './custom/mutations';
import { auditsPage, getConsolidatedUserById, manifestReports, onfleetWorkersForRoutes, packages as customPackages, packagesByIdentifierAdmin, packagesByIdentifierCustom, packageTrackingListExpanded, partner as partnerCustom, partnerForSavers, trips, tripsPage, user, usersForSavers, } from './custom/queries';
import { onManifestReportUpdate, onPackageUpdateSubscriptionCustom, onTripUpdate, } from './custom/subscriptions';
import { addUserToDriver, addUserToHub as addUserToHubMutation, addUserToPartner, applyPartnerPromoCode as applyPartnerPromoCodeMutation, applyPromoCode as applyPromoCodeMutation, assignSaverToTripAudit, assignUserToTripAudit, batchUpdateServicedZipCodes as batchUpdateServicedZipCodesMutation, batchUpdateTrip as batchUpdateTripMutation, calculateRoutePricing, clearPackageTrackingId as clearPackageTrackingIdMutation, clearRequiresAgeVerification as clearRequiresAgeVerificationMutation, completeSaverReviewForTripAudit, completeTripAudit, confirmTrip as confirmTripMutation, createAddress as createAddressMutation, createAreaDemand as createAreaDemandMutation, createConsolidation, createConsolidationPackage, createDriverReliability, createLabelUploadUrl as createLabelUploadUrlMutation, createLocation, createOrderWithItems as createOrderWithItemsMutation, createOutboundConsolidation, createPackage as createPackageMutation, createPartner, createPartnerAttribute as createPartnerAttributeMutation, createPartnerDestination, createPartnerPaymentIntent as createPartnerPaymentIntentMutation, createPartnerPrice as createPartnerPriceMutation, createPartnerTrip as createPartnerTripMutation, createPartnerUser, createPaymentIntent as createPaymentIntentMutation, createPolybags, createRetailer, createRouteEntitlements, createSubscription as createSubscriptionMutation, createTrip as createTripMutation, createTripAudit, createTripMedia, createUserAddress, createZone as createZoneMutation, deleteAddress as deleteAddressMutation, deleteAddressById as deleteAddressByIdMutation, deleteConsolidationPackage, deletePackage, deletePartnerAttribute as deletePartnerAttributeMutation, deletePartnerDestination, deletePartnerPrice as deletePartnerPriceMutation, deleteScan, deleteTrip as deleteTripMutation, deleteTripMedia, deleteUserFromPartner, deleteZone as deleteZoneMutation, importManifest as importManifestMutation, includeZipCodes, modifyRoute, newDriverApplication, processPolybagScan, processQRCodeScan, processScan as processScanMutation, recoverUserAccount, refreshTripEATValue, registerConsolidationScan, removeUserHub as removeUserHubMutation, reschedule, resetUserPassword, savePartnerContact as savePartnerContactMutation, sendComms as sendCommsMutation, setBadCompletionNotes, togglePartner, togglePartnerShop, toggleZipCode as toggleZipCodeMutation, updateAddress as updateAddressMutation, updateConsolidation, updateLocation, updateManifestReportErrors as updateManifestReportErrorsMutation, updatePackage as updatePackageMutation, updatePartner, updatePartnerAttribute as updatePartnerAttributeMutation, updatePartnerPrice as updatePartnerPriceMutation, updatePassword as updatePasswordMutation, updateRole as updateRoleMutation, updateTrip as updateTripMutation, updateTripCSAT, updateTripPackagesAddressId as updateTripPackagesAddressIdMutation, updateUser as updateUserMutation, updateZone as updateZoneMutation, upsertPreviousAddressPackage as upsertPreviousAddressPackageMutation, upsertPreviousAddressTrip as upsertPreviousAddressTripMutation, } from './generated/mutations';
import { carriers, checkEmail, consolidations, dashboard, deliveriesByPhone, drivers, driverTripByTripId, driverTrips, eATRecencyThreshold, getAddressValidationFeedback, getBaseRoutes, getDummyDriversByHubId, getLocation, getPackage, getPackageConsolidation, getUserRecentTrips, holidays, hubs, jobs, locations, manifestFile, manifestFiles, manifestReport, missingPackages, onfleetWorkers, orderItems, packages, packagesByCarrier, packageServiceTypes, packageSummary, packageTrackingList, packingSlipByConsolidationId, partner, partners, partnerShop, partnerShops, paymentMethods, paymentMethodsByEmail, retailers, returnReasons, route, servicedZipCodes, signedLabelUrl, trip, tripETAValue, tripSummary, userById, userRole, usersByDate, usersBySearch, } from './generated/queries';
import { onAsyncJobStatusUpdate, onTripAuditUpdate } from './generated/subscriptions';
import { notificationReport } from './generatedNotifications/queries';
import { operationReport, operationReports } from './generatedPartner/queries';
import { onOperationReportUpdate } from './generatedPartner/subscriptions';
var CallApi = /** @class */ (function () {
    function CallApi() {
        var _this = this;
        this.clientPrivate = null;
        this.config = getConfig();
        this.testsEnabled = process.env.JEST_WORKER_ID;
        this.configs = { fetch: this.testsEnabled ? require('cross-fetch') : undefined };
        this.httpLink = new HttpLink(__assign({ uri: this.config.aws.graphqlEndpoint }, this.configs));
        this.partnerHttpLink = new HttpLink(__assign({ uri: this.config.aws.graphqlPartnerEndpoint }, this.configs));
        this.notificationsHttpLink = new HttpLink(__assign({ uri: this.config.aws.graphqlNotificationsEndpoint }, this.configs));
        this.createPrivateLink = function () { return __awaiter(_this, void 0, void 0, function () {
            var accessToken, subscriptionLink, privateLink, authErrorHandler;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.testsEnabled) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, StandingStore.getItem('idToken')];
                    case 1:
                        accessToken = _a.sent();
                        if (!accessToken) {
                            return [2 /*return*/];
                        }
                        subscriptionLink = ApolloLink.from([
                            createAuthLink({
                                url: this.testsEnabled ? '' : this.config.aws.graphqlEndpoint,
                                region: this.config.aws.region,
                                auth: {
                                    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
                                    jwtToken: accessToken,
                                },
                            }),
                            createSubscriptionHandshakeLink({
                                url: this.testsEnabled ? '' : this.config.aws.graphqlEndpoint,
                                region: this.config.aws.region,
                                auth: {
                                    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
                                    jwtToken: accessToken,
                                },
                            }),
                        ]);
                        this.subscriptionClient = new ApolloClient({
                            link: subscriptionLink,
                            cache: new InMemoryCache({ addTypename: false }),
                        });
                        privateLink = ApolloLink.from([
                            createAuthLink({
                                url: this.testsEnabled ? '' : this.config.aws.graphqlEndpoint,
                                region: this.config.aws.region,
                                auth: {
                                    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
                                    jwtToken: accessToken,
                                },
                            }),
                            this.httpLink,
                        ]);
                        this.clientPrivate = new ApolloClient({
                            link: privateLink,
                            cache: new InMemoryCache({
                                typePolicies: {
                                    Partner: {
                                        keyFields: ['code'],
                                    },
                                },
                            }),
                            credentials: 'includes',
                        });
                        authErrorHandler = {
                            apply: function (target, // eslint-disable-line
                            _, // eslint-disable-line
                            variables) { return __awaiter(_this, void 0, void 0, function () {
                                var err_1, message, user_1, err_2, message_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 11]);
                                            return [4 /*yield*/, target(variables[0])];
                                        case 1: return [2 /*return*/, _a.sent()];
                                        case 2:
                                            err_1 = _a.sent();
                                            message = err_1.message;
                                            if (!message.includes('401')) return [3 /*break*/, 9];
                                            return [4 /*yield*/, Auth.currentAuthenticatedUser()];
                                        case 3:
                                            user_1 = _a.sent();
                                            StandingStore.setItem('accessToken', user_1.signInUserSession.accessToken.jwtToken);
                                            StandingStore.setItem('idToken', user_1.signInUserSession.idToken.jwtToken);
                                            StandingStore.setItem('refreshToken', user_1.signInUserSession.refreshToken.token);
                                            return [4 /*yield*/, this.createPrivateLink()];
                                        case 4:
                                            _a.sent();
                                            _a.label = 5;
                                        case 5:
                                            _a.trys.push([5, 7, , 8]);
                                            return [4 /*yield*/, target.apply(void 0, variables)];
                                        case 6: return [2 /*return*/, _a.sent()];
                                        case 7:
                                            err_2 = _a.sent();
                                            message_1 = err_2.message;
                                            throw new Error(message_1);
                                        case 8: return [3 /*break*/, 10];
                                        case 9: throw new Error(message);
                                        case 10: return [3 /*break*/, 11];
                                        case 11: return [2 /*return*/];
                                    }
                                });
                            }); },
                        };
                        this.clientPrivate.query = new Proxy(this.clientPrivate.query, authErrorHandler);
                        this.clientPrivate.mutate = new Proxy(this.clientPrivate.mutate, authErrorHandler);
                        return [2 /*return*/];
                }
            });
        }); };
        this.removePrivateLink = function () {
            _this.clientPrivate = null;
        };
        this.createAddress = function (input, skipServicedArea) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), createAddressMutation),
                    variables: {
                        input: input,
                        skipServicedArea: skipServicedArea,
                    },
                });
            }
        };
        this.deleteAddress = function (id) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), deleteAddressMutation),
                    variables: {
                        id: id,
                    },
                });
            }
        };
        this.deleteAddressById = function (id) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), deleteAddressByIdMutation),
                    variables: {
                        id: id,
                    },
                });
            }
        };
        this.updateAddress = function (_a) {
            var id = _a.id, input = _a.input, skipServicedArea = _a.skipServicedArea;
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), updateAddressMutation),
                variables: {
                    id: id,
                    input: input,
                    skipServicedArea: skipServicedArea,
                },
            });
        };
        this.upsertPreviousAddressTrip = function (_a) {
            var tripId = _a.tripId, input = _a.input;
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), upsertPreviousAddressTripMutation),
                variables: { tripId: tripId, input: input },
            });
        };
        this.upsertPreviousAddressPackage = function (_a) {
            var packageId = _a.packageId, input = _a.input;
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), upsertPreviousAddressPackageMutation),
                variables: {
                    packageId: packageId,
                    input: input,
                },
            });
        };
        this.createLabelUploadUrl = function (data) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createLabelUploadUrlMutation),
                variables: __assign({ region: '', bucket: '' }, data),
            });
        };
        this.createPartnerTrip = function (data) {
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createPartnerTripMutation),
                variables: __assign({}, data),
            });
        };
        this.getPartner = function (code) {
            return _this.clientPublic.query({
                query: gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), partner),
                variables: {
                    code: code,
                },
            });
        };
        this.getServerSidePartner = function (code) {
            return _this.clientPublic.query({
                query: gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), partnerCustom),
                variables: {
                    code: code,
                },
                fetchPolicy: 'no-cache',
            });
        };
        this.getUser = function () {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), user),
                    fetchPolicy: 'network-only',
                });
            }
        };
        this.getUserRecentTrips = function (id) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), getUserRecentTrips),
                    variables: {
                        id: id,
                    },
                });
            }
        };
        this.getSignedLabelUrl = function (url) {
            return _this.clientPublic.query({
                query: gql(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), signedLabelUrl),
                variables: {
                    url: url,
                },
            });
        };
        this.createAreaDemand = function (_a) {
            var email = _a.email, zipCode = _a.zipCode;
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createAreaDemandMutation),
                variables: {
                    email: email,
                    zipCode: zipCode,
                },
            });
        };
        this.createTrip = function (createTrip) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createTripMutation),
                variables: __assign({}, createTrip),
            });
        };
        this.createPackage = function (createPackage) {
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createPackageMutation),
                variables: createPackage,
            });
        };
        this.clearPackageTrackingId = function (clearPackageTrackingId) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), clearPackageTrackingIdMutation),
                    variables: clearPackageTrackingId,
                });
            }
        };
        this.clearRequiresAgeVerification = function (clearRequiresAgeVerification) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), clearRequiresAgeVerificationMutation),
                    variables: clearRequiresAgeVerification,
                });
            }
        };
        this.deletePackage = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), deletePackage),
                    variables: variables,
                });
            }
        };
        this.deleteTrip = function (variables) {
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), deleteTripMutation),
                variables: variables,
            });
        };
        this.applyPromoCode = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), applyPromoCodeMutation),
                    variables: variables,
                });
            }
        };
        this.applyPartnerPromoCode = function (variables) {
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), applyPartnerPromoCodeMutation),
                variables: variables,
            });
        };
        this.createPartnerPaymentIntent = function (variables) {
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createPartnerPaymentIntentMutation),
                variables: variables,
            });
        };
        this.createPaymentIntent = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), createPaymentIntentMutation),
                    variables: variables,
                });
            }
        };
        this.createSubscription = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), createSubscriptionMutation),
                    variables: variables,
                });
            }
        };
        this.getPaymentMethods = function () {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), paymentMethods),
                });
            }
        };
        this.updateUser = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), updateUserMutation),
                    variables: variables,
                });
            }
        };
        this.confirmTrip = function (variables) {
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), confirmTripMutation),
                variables: variables,
            });
        };
        this.updatePassword = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), updatePasswordMutation),
                    variables: variables,
                });
            }
        };
        this.getHubs = function () {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), hubs),
                fetchPolicy: 'no-cache',
            });
        };
        this.servicedZipCodes = function (_a) {
            var where = _a.where, order = _a.order;
            return _this.clientPublic.query({
                query: gql(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), servicedZipCodes),
                variables: {
                    where: where,
                    order: order,
                },
                fetchPolicy: 'no-cache',
            });
        };
        this.getTrips = function (_a) {
            var where = _a.where, pagination = _a.pagination, order = _a.order;
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), trips),
                    variables: {
                        where: where,
                        pagination: pagination,
                        order: order,
                    },
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getRoutes = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), getBaseRoutes),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getRoute = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), route),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.modifyRoute = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), modifyRoute),
                variables: variables,
            });
        };
        this.createDriverReliability = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createDriverReliability),
                variables: variables,
            });
        };
        this.getTripsPage = function (_a) {
            var where = _a.where, pagination = _a.pagination, order = _a.order;
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), tripsPage),
                    variables: {
                        where: where,
                        pagination: pagination,
                        order: order,
                    },
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getAuditsPage = function (_a) {
            var where = _a.where, pagination = _a.pagination, order = _a.order;
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), auditsPage),
                    variables: {
                        where: where,
                        pagination: pagination,
                        order: order,
                    },
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getPackagesByCarrier = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), packagesByCarrier),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getUsersByDate = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), usersByDate),
                    variables: variables,
                });
            }
        };
        this.getUserById = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), userById),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.getConsolidatedUserById = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), getConsolidatedUserById),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.getUsers = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), usersBySearch),
                    variables: variables,
                });
            }
        };
        this.getUsersForSavers = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), usersForSavers),
                    variables: variables,
                });
            }
        };
        this.getAddressValidationFeedback = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), getAddressValidationFeedback),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getPackages = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), customPackages),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.getPackagesByIdentifier = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), packagesByIdentifierCustom),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.getPackagesByIdentifierAdmin = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), packagesByIdentifierAdmin),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.getPublicPackages = function (variables) {
            return _this.clientPublic.query({
                query: gql(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), packages),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.getPackage = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), getPackage),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.processScan = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), processScanMutation),
                    variables: variables,
                });
            }
        };
        this.deleteScan = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), deleteScan),
                variables: variables,
            });
        };
        this.registerConsolidationScan = function (variables) {
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), registerConsolidationScan),
                variables: variables,
            });
        };
        this.processQRCodeScan = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), processQRCodeScan),
                variables: variables,
            });
        };
        this.getPaymentMethodsByEmail = function (variables) {
            return _this.clientPublic.query({
                query: gql(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), paymentMethodsByEmail),
                variables: variables,
            });
        };
        this.updateTrip = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), updateTripMutation),
                variables: variables,
            });
        };
        this.updatePackage = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), updatePackageMutation),
                variables: variables,
            });
        };
        this.getCarriers = function () {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), carriers),
                });
            }
        };
        this.getRetailers = function () {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), retailers),
                });
            }
        };
        this.createRetailer = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), createRetailer),
                    variables: variables,
                });
            }
        };
        this.getManifest = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), manifestReport),
                    fetchPolicy: 'no-cache',
                    variables: variables,
                });
            }
        };
        this.importManifest = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_62 || (templateObject_62 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), importManifestMutation),
                    variables: variables,
                });
            }
        };
        this.getManifests = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_63 || (templateObject_63 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), manifestReports),
                    fetchPolicy: 'no-cache',
                    variables: variables,
                });
            }
        };
        this.getFiles = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_64 || (templateObject_64 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), manifestFiles),
                    variables: variables,
                });
            }
        };
        this.onManifestReportUpdate = function () {
            if (_this.subscriptionClient) {
                return _this.subscriptionClient.subscribe({
                    query: gql(templateObject_65 || (templateObject_65 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), onManifestReportUpdate),
                    errorPolicy: 'ignore',
                });
            }
        };
        this.onTripUpdate = function () {
            if (_this.subscriptionClient) {
                return _this.subscriptionClient.subscribe({
                    query: gql(templateObject_66 || (templateObject_66 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), onTripUpdate),
                    errorPolicy: 'ignore',
                });
            }
            else if (_this.subscriptionClientPublic) {
                return _this.subscriptionClientPublic.subscribe({
                    query: gql(templateObject_67 || (templateObject_67 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), onTripUpdate),
                    errorPolicy: 'ignore',
                });
            }
        };
        this.onTripAuditUpdate = function () {
            if (_this.subscriptionClient) {
                return _this.subscriptionClient.subscribe({
                    query: gql(templateObject_68 || (templateObject_68 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), onTripAuditUpdate),
                    errorPolicy: 'ignore',
                });
            }
            else if (_this.subscriptionClientPublic) {
                return _this.subscriptionClientPublic.subscribe({
                    query: gql(templateObject_69 || (templateObject_69 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), onTripAuditUpdate),
                    errorPolicy: 'ignore',
                });
            }
        };
        this.onPackageUpdate = function () {
            if (_this.subscriptionClient) {
                return _this.subscriptionClient.subscribe({
                    query: gql(templateObject_70 || (templateObject_70 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), onPackageUpdateSubscriptionCustom),
                    errorPolicy: 'ignore',
                });
            }
            else if (_this.subscriptionClientPublic) {
                return _this.subscriptionClientPublic.subscribe({
                    query: gql(templateObject_71 || (templateObject_71 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), onPackageUpdateSubscriptionCustom),
                    errorPolicy: 'ignore',
                });
            }
        };
        this.onAsyncJobStatusUpdate = function () {
            if (_this.subscriptionClient) {
                return _this.subscriptionClient.subscribe({
                    query: gql(templateObject_72 || (templateObject_72 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), onAsyncJobStatusUpdate),
                    errorPolicy: 'ignore',
                });
            }
        };
        this.toggleZipCode = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_73 || (templateObject_73 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), toggleZipCodeMutation),
                    variables: variables,
                });
            }
        };
        this.createZone = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_74 || (templateObject_74 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), createZoneMutation),
                    variables: variables,
                });
            }
        };
        this.updateZone = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_75 || (templateObject_75 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), updateZoneMutation),
                    variables: variables,
                });
            }
        };
        this.batchUpdateServicedZipCodes = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_76 || (templateObject_76 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), batchUpdateServicedZipCodesMutation),
                    variables: variables,
                });
            }
        };
        this.deleteZone = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_77 || (templateObject_77 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), deleteZoneMutation),
                    variables: variables,
                });
            }
        };
        this.includeZipCodes = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_78 || (templateObject_78 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), includeZipCodes),
                    variables: variables,
                });
            }
        };
        this.sendComms = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_79 || (templateObject_79 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), sendCommsMutation),
                    variables: variables,
                });
            }
        };
        this.createTripMedia = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_80 || (templateObject_80 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), createTripMedia),
                    variables: variables,
                });
            }
        };
        this.deleteTripMedia = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_81 || (templateObject_81 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), deleteTripMedia),
                    variables: variables,
                });
            }
        };
        this.manifestFile = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_82 || (templateObject_82 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), manifestFile),
                    variables: variables,
                });
            }
        };
        this.getDashboardData = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_83 || (templateObject_83 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), dashboard),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getMissingPackages = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_84 || (templateObject_84 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), missingPackages),
                    variables: variables,
                });
            }
        };
        this.getPartners = function (_a) {
            var noCache = _a.noCache;
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_85 || (templateObject_85 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), partners),
                    fetchPolicy: noCache ? 'network-only' : 'cache-first',
                });
            }
        };
        this.getPartnersForSavers = function (_a) {
            var noCache = _a.noCache;
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_86 || (templateObject_86 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), partnerForSavers),
                    fetchPolicy: noCache ? 'network-only' : 'cache-first',
                });
            }
        };
        this.createPartnerUser = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_87 || (templateObject_87 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), createPartnerUser),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getTrip = function (variables) {
            return _this.clientPublic.query({
                query: gql(templateObject_88 || (templateObject_88 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), trip),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.getDriverTripByTripId = function (variables) {
            return _this.clientPublic.query({
                query: gql(templateObject_89 || (templateObject_89 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), driverTripByTripId),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.getDriverTrips = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_90 || (templateObject_90 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), driverTrips),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.executeRoutePricing = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_91 || (templateObject_91 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), calculateRoutePricing),
                variables: variables,
            });
        };
        this.createUserAddress = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_92 || (templateObject_92 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createUserAddress),
                variables: variables,
            });
        };
        this.getDeliveriesByPhone = function (variables) {
            return _this.clientPublic.query({
                query: gql(templateObject_93 || (templateObject_93 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), deliveriesByPhone),
                variables: variables,
            });
        };
        this.updateManifestReportErrors = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_94 || (templateObject_94 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), updateManifestReportErrorsMutation),
                    variables: variables,
                });
            }
        };
        this.addPartnerContact = function (variables) {
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_95 || (templateObject_95 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), savePartnerContactMutation),
                variables: variables,
            });
        };
        this.addDriverContact = function (variables) {
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_96 || (templateObject_96 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), newDriverApplication),
                variables: variables,
            });
        };
        this.batchUpdateTrip = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_97 || (templateObject_97 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), batchUpdateTripMutation),
                    variables: variables,
                });
            }
        };
        this.getTripSummary = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_98 || (templateObject_98 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), tripSummary),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getPackageSummary = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_99 || (templateObject_99 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), packageSummary),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.getOnfleetWorkers = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_100 || (templateObject_100 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), onfleetWorkers),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getOnfleetWorkersForRoutes = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_101 || (templateObject_101 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), onfleetWorkersForRoutes),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getDummyDriversByHubId = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_102 || (templateObject_102 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), getDummyDriversByHubId),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.getDrivers = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_103 || (templateObject_103 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), drivers),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.holidays = function (variables) {
            return _this.clientPublic.query({
                query: gql(templateObject_104 || (templateObject_104 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), holidays),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.userRole = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_105 || (templateObject_105 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), userRole),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.updateUserRole = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_106 || (templateObject_106 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), updateRoleMutation),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.removeUserHub = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_107 || (templateObject_107 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), removeUserHubMutation),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.addUserToHub = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_108 || (templateObject_108 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), addUserToHubMutation),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.checkEmail = function (variables) {
            return _this.clientPublic.query({
                query: gql(templateObject_109 || (templateObject_109 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), checkEmail),
                variables: variables,
            });
        };
        this.togglePartner = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_110 || (templateObject_110 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), togglePartner),
                    variables: variables,
                    update: function (cache, _a) {
                        var data = _a.data;
                        var partnersCache = cache.readQuery({
                            query: gql(templateObject_111 || (templateObject_111 = __makeTemplateObject(["\n              ", "\n            "], ["\n              ", "\n            "])), partners),
                        });
                        var updatesPartners = partnersCache === null || partnersCache === void 0 ? void 0 : partnersCache.partners.map(function (p) {
                            return p.code === (data === null || data === void 0 ? void 0 : data.togglePartner) ? __assign(__assign({}, p), { isActive: !p.isActive }) : p;
                        });
                        cache.writeQuery({
                            query: gql(templateObject_112 || (templateObject_112 = __makeTemplateObject(["\n              ", "\n            "], ["\n              ", "\n            "])), partners),
                            data: {
                                partners: __spreadArray([], (updatesPartners || []), true),
                            },
                        });
                    },
                });
            }
        };
        this.createPartner = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_113 || (templateObject_113 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), createPartner),
                    variables: variables,
                    update: function (cache, _a) {
                        var data = _a.data;
                        var partnersCache = cache.readQuery({
                            query: gql(templateObject_114 || (templateObject_114 = __makeTemplateObject(["\n              ", "\n            "], ["\n              ", "\n            "])), partners),
                        });
                        cache.writeQuery({
                            query: gql(templateObject_115 || (templateObject_115 = __makeTemplateObject(["\n              ", "\n            "], ["\n              ", "\n            "])), partners),
                            data: {
                                partners: __spreadArray(__spreadArray([], ((partnersCache === null || partnersCache === void 0 ? void 0 : partnersCache.partners) || []), true), [data === null || data === void 0 ? void 0 : data.createPartner], false),
                            },
                        });
                    },
                });
            }
        };
        this.updatePartner = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_116 || (templateObject_116 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), updatePartner),
                    variables: variables,
                    update: function (cache, _a) {
                        var data = _a.data;
                        var cacheId = cache.identify({ __typename: 'Partner', code: data === null || data === void 0 ? void 0 : data.updatePartner.code });
                        cache.modify({
                            fields: {
                                Partner: function (existingFieldData, _a) {
                                    var toReference = _a.toReference;
                                    return __spreadArray(__spreadArray([], existingFieldData, true), [toReference(cacheId)], false);
                                },
                            },
                        });
                    },
                });
            }
        };
        this.createPartnerAttribute = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_117 || (templateObject_117 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), createPartnerAttributeMutation),
                    variables: variables,
                });
            }
        };
        this.updatePartnerAttribute = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_118 || (templateObject_118 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), updatePartnerAttributeMutation),
                    variables: variables,
                });
            }
        };
        this.deletePartnerAttribute = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_119 || (templateObject_119 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), deletePartnerAttributeMutation),
                    variables: variables,
                });
            }
        };
        this.createPartnerPrice = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_120 || (templateObject_120 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), createPartnerPriceMutation),
                    variables: variables,
                });
            }
        };
        this.updatePartnerPrice = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_121 || (templateObject_121 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), updatePartnerPriceMutation),
                    variables: variables,
                });
            }
        };
        this.deletePartnerPrice = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_122 || (templateObject_122 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), deletePartnerPriceMutation),
                    variables: variables,
                });
            }
        };
        this.createOrderWithItems = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_123 || (templateObject_123 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), createOrderWithItemsMutation),
                    variables: variables,
                });
            }
        };
        this.getJobs = function () {
            return _this.clientPublic.query({
                query: gql(templateObject_124 || (templateObject_124 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), jobs),
            });
        };
        this.getOrderItems = function (variables) {
            return _this.clientPublic.query({
                query: gql(templateObject_125 || (templateObject_125 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), orderItems),
                variables: variables,
            });
        };
        this.getTripETAValue = function (variables) {
            return _this.clientPublic.query({
                query: gql(templateObject_126 || (templateObject_126 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), tripETAValue),
                variables: variables,
            });
        };
        this.refreshTripEATValue = function (variables) {
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_127 || (templateObject_127 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), refreshTripEATValue),
                variables: variables,
            });
        };
        this.getEATRecencyThreshold = function () {
            return _this.clientPublic.query({
                query: gql(templateObject_128 || (templateObject_128 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), eATRecencyThreshold),
            });
        };
        this.getReturnReasons = function (variables) {
            return _this.clientPublic.query({
                query: gql(templateObject_129 || (templateObject_129 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), returnReasons),
                variables: variables,
            });
        };
        this.deleteUserFromPartner = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_130 || (templateObject_130 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), deleteUserFromPartner),
                    variables: variables,
                });
            }
        };
        this.createUserForPartner = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_131 || (templateObject_131 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), addUserToPartner),
                    variables: variables,
                });
            }
        };
        this.getPartnerShops = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_132 || (templateObject_132 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), partnerShops),
                    variables: variables,
                });
            }
        };
        this.togglePartnerShop = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.mutate({
                    mutation: gql(templateObject_133 || (templateObject_133 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), togglePartnerShop),
                    variables: variables,
                });
            }
        };
        this.getPartnerShop = function (variables) {
            return _this.clientPublic.query({
                query: gql(templateObject_134 || (templateObject_134 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), partnerShop),
                variables: variables,
            });
        };
        this.operationReports = function (variables) {
            return _this.clientPartnerPublic.query({
                query: gql(templateObject_135 || (templateObject_135 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), operationReports),
                variables: variables,
            });
        };
        this.operationReport = function (variables) {
            return _this.clientPartnerPublic.query({
                query: gql(templateObject_136 || (templateObject_136 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), operationReport),
                variables: variables,
            });
        };
        this.onOperationReportUpdate = function () {
            if (_this.partnerSubscriptionClient) {
                return _this.partnerSubscriptionClient.subscribe({
                    query: gql(templateObject_137 || (templateObject_137 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), onOperationReportUpdate),
                    errorPolicy: 'ignore',
                });
            }
        };
        this.getConsolidations = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_138 || (templateObject_138 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), consolidations),
                fetchPolicy: 'no-cache',
                variables: variables,
            });
        };
        this.getContainers = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_139 || (templateObject_139 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), consolidations),
                fetchPolicy: 'no-cache',
                variables: variables,
            });
        };
        this.getConsolidationById = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_140 || (templateObject_140 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), consolidations),
                fetchPolicy: 'no-cache',
                variables: variables,
            });
        };
        this.getPackageConsolidation = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_141 || (templateObject_141 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), getPackageConsolidation),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.createConsolidation = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_142 || (templateObject_142 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createConsolidation),
                variables: variables,
            });
        };
        this.createOutboundConsolidation = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_143 || (templateObject_143 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createOutboundConsolidation),
                variables: variables,
            });
        };
        this.updateConsolidation = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_144 || (templateObject_144 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), updateConsolidation),
                variables: variables,
            });
        };
        this.createConsolidationPackage = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_145 || (templateObject_145 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createConsolidationPackage),
                variables: variables,
            });
        };
        this.deleteConsolidationPackage = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_146 || (templateObject_146 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), deleteConsolidationPackage),
                variables: variables,
            });
        };
        this.createPartnerDestination = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_147 || (templateObject_147 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createPartnerDestination),
                variables: variables,
            });
        };
        this.deletePartnerDestination = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_148 || (templateObject_148 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), deletePartnerDestination),
                variables: variables,
            });
        };
        this.getPackingSlipByConsolidationId = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_149 || (templateObject_149 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), packingSlipByConsolidationId),
                    variables: variables,
                });
            }
        };
        this.notificationReport = function (variables) {
            return _this.clientNotificationsPublic.query({
                query: gql(templateObject_150 || (templateObject_150 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), notificationReport),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.updateTripCSAT = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_151 || (templateObject_151 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), updateTripCSAT),
                variables: variables,
            });
        };
        this.getPackageServiceTypes = function () {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_152 || (templateObject_152 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), packageServiceTypes),
            });
        };
        this.getLocations = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_153 || (templateObject_153 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), locations),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.getLocation = function (variables) {
            if (_this.clientPrivate) {
                return _this.clientPrivate.query({
                    query: gql(templateObject_154 || (templateObject_154 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), getLocation),
                    variables: variables,
                    fetchPolicy: 'no-cache',
                });
            }
        };
        this.createLocation = function (variables) {
            return _this.clientPublic.mutate({
                mutation: gql(templateObject_155 || (templateObject_155 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createLocation),
                variables: variables,
            });
        };
        this.updateLocation = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_156 || (templateObject_156 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), updateLocation),
                variables: variables,
            });
        };
        this.reschedule = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_157 || (templateObject_157 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), reschedule),
                variables: variables,
            });
        };
        this.getPackageTrackingList = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_158 || (templateObject_158 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), packageTrackingList),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.getPackageTrackingListExpanded = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).query({
                query: gql(templateObject_159 || (templateObject_159 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), packageTrackingListExpanded),
                variables: variables,
                fetchPolicy: 'no-cache',
            });
        };
        this.addUserToDriver = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_160 || (templateObject_160 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), addUserToDriver),
                variables: variables,
            });
        };
        this.updateTripPackagesAddressId = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_161 || (templateObject_161 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), updateTripPackagesAddressIdMutation),
                variables: variables,
            });
        };
        this.splitPackageByAddressId = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_162 || (templateObject_162 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), splitPackageByAddressIdMutation),
                variables: variables,
            });
        };
        this.createTripAudit = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_163 || (templateObject_163 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createTripAudit),
                variables: variables,
            });
        };
        this.assignUserToTripAudit = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_164 || (templateObject_164 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), assignUserToTripAudit),
                variables: variables,
            });
        };
        this.completeTripAudit = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_165 || (templateObject_165 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), completeTripAudit),
                variables: variables,
            });
        };
        this.completeSaverReviewForTripAudit = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_166 || (templateObject_166 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), completeSaverReviewForTripAudit),
                variables: variables,
            });
        };
        this.assignSaverToTripAudit = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_167 || (templateObject_167 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), assignSaverToTripAudit),
                variables: variables,
            });
        };
        this.setBadCompletionNotes = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_168 || (templateObject_168 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), setBadCompletionNotes),
                variables: variables,
            });
        };
        this.recoverUserAccount = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_169 || (templateObject_169 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), recoverUserAccount),
                variables: variables,
            });
        };
        this.resetUserPassword = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_170 || (templateObject_170 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), resetUserPassword),
                variables: variables,
            });
        };
        this.createPolybags = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_171 || (templateObject_171 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createPolybags),
                variables: variables,
            });
        };
        this.processPolybagScan = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_172 || (templateObject_172 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), processPolybagScan),
                variables: variables,
            });
        };
        this.createRouteEntitlements = function (variables) {
            return (_this.clientPrivate || _this.clientPublic).mutate({
                mutation: gql(templateObject_173 || (templateObject_173 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), createRouteEntitlements),
                variables: variables,
            });
        };
        // TODO: rework on real api request
        this.getBlog = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        data: {
                            blog: {
                                id: '1',
                                img: '/assets/images/mainArticleImg.jpg',
                                title: 'Returnmates Raises $5 Million To Make At-Home Return Pickups',
                                articleTitle: 'Returnmates Raises $5 Million To Make At-Home Return Pickups the New (And Long Overdue) Norm',
                                firstParagraph: 'Today, we’re launching Returnmates for anyone. We pick up returns purchased from any online retailer. No more printing labels, packaging or trips to the post office',
                                author: {
                                    name: 'Kristian Zak',
                                    avatar: 'https://www.returnmates.com/assets/images/Kristian.png',
                                    role: 'Co-Founder & CMO',
                                },
                                date: 'Oct 13, 2021',
                                timeToRead: '3 min',
                                paragraphs: [
                                    {
                                        type: 'HEADER',
                                        data: 'We’ve expanded to San Francisco, Miami, Houston, and Austin and have partnered with retailers and marketplaces like Rent The Runway, Mercari and more.',
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "You can order anything online with just a few clicks, yet returns are anything but easy. Every year, hundreds of millions of dollars worth of consumer goods lay dormant in people\u2019s homes because buyers weren\u2019t able to return their items on time, or it was simply too much of a hassle to. The outdated returns system is a problem - to the detriment of  both consumers and brands.",
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "During the COVID-19 pandemic, we\u2019ve seen consumer expectations around online shopping as we were forced to make that our primary form of commerce. Retailers have responded by making the buying process easier. Yet we have heard consistently that the returns process is clearly not catching up to the seamless shopping experience consumers now expect.",
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "In fact, returns are the number one headache for retailers, but businesses also want to get it right because to put it pretty simply, it\u2019s better for business. Retailers not only lose out on repeat customers when they aren't happy with the returns experience, they also have to spend more to staff customer service teams to handle the influx of returns requests.\n              ",
                                    },
                                    {
                                        type: 'IMAGE',
                                        data: '/assets/images/pickupImg.jpg',
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "We\u2019re completely changing how both businesses and consumers view returns, one seamless pick-up at a time. With next day pick-ups dispatched in 30 minute windows, a platform that enables live customer support along the way, and real time tracking, returns can be done without ever leaving your home - no printing labels, no waiting in line, and no reaching for the roll of tape.",
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "Today, we\u2019re excited to announce that we\u2019ve expanded outside of our home city of Los Angeles to San Francisco, Miami, Houston, and Austin and we\u2019ve raised $5 million in new funding led by LightShed Ventures to help fuel our expansion.\n              ",
                                    },
                                    {
                                        type: 'QUOTE',
                                        data: "\u201CWe\u2019ve expanded to San Francisco, Miami, Houston, and Austin and have partnered with retailers and marketplaces like Rent The Runway, Mercari and more.\u201D",
                                        options: {
                                            italic: true,
                                        },
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "We\u2019re also pumped to welcome Good Friends (founders of Allbirds, Warby Parker and Harry\u2019s), Chris Homer (thredUP Co-Founder and COO), and V1.VC to our growing list of backers, which includes Graph Ventures and angel investors from companies like Uber, Instacart, Dropbox, Slack, Facebook, and more.",
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "The more comfort people have with returns, the more they shop.",
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "According to a recent consumer report, 80 percent of people surveyed always check shipping and return policies before they complete a purchase and 50 percent said these policies often determine whether or not they buy an item. ",
                                    },
                                    {
                                        type: 'IMAGE',
                                        data: '/assets/images/mainArticleImg.jpg',
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "The data clearly supports our case for building a customer-centric returns and first-mile pickup service and that\u2019s why businesses like Rent The Runway, and other large retailers are working alongside us to change the consumer experience by offering as early as next-day pickups to their customers.",
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "We also partner with online marketplaces like Mercari to provide a white-glove shipping experience for sellers. Our next-day pickup service significantly reduces the friction surrounding the shipping process. Sellers can simply choose their preferred date and we\u2019ll pick up, package, and ship the items for them.",
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "By providing a platform that enables next-day batched routes, we reduce the number of people driving to and from the post office, FedEx / UPS stores, etc. And by consolidating returns for brands (i.e. putting more returns in fewer boxes) we create a more efficient and sustainable supply chain. This dramatically reduces the number of boxes in circulation and drives significant return shipping savings for brands.",
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "To date, we\u2019ve returned more than 10 million dollars worth of returns to retailers, and garnered a 99 percent customer satisfaction score by delighting thousands of customers along the way with the Returnmates platform. We\u2019ve also seen up to 74 percent month over month growth in the past few months as we continue to ramp up our operations. ",
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "Moving forward, we\u2019re excited about expanding to even more US cities (we have ambitious plans!), adding more drivers to the platform, growing our internal engineering and product teams, partnering with more retailers, and continuing to create a universal returns experience enabling us to potentially offer unique features like one click returns, real time tracking, instant refunds, and more.",
                                    },
                                    {
                                        type: 'COMMON',
                                        data: "We\u2019re just getting started - more soon! ",
                                        options: {
                                            bold: true,
                                        },
                                    },
                                ],
                            },
                        },
                    }];
            });
        }); };
        // TODO: rework on real api request
        this.getBlogs = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        data: {
                            blogs: {
                                blogs: [
                                    {
                                        id: '1',
                                        img: '/assets/images/mainArticleImg.jpg',
                                        title: 'Returnmates Raises $5 Million To Make At-Home Return Pickups',
                                        articleTitle: 'Returnmates Raises $5 Million To Make At-Home Return Pickups the New (And Long Overdue) Norm',
                                        firstParagraph: 'Today, we’re launching Returnmates for anyone. We pick up returns purchased from any online retailer. No more printing labels, packaging or trips to the post office',
                                        author: {
                                            name: 'Kristian Zak',
                                            avatar: 'https://www.returnmates.com/assets/images/Kristian.png',
                                            role: 'Co-Founder & CMO',
                                        },
                                        date: 'Oct 13, 2021',
                                        timeToRead: '3 min',
                                        paragraphs: [
                                            {
                                                type: 'HEADER',
                                                data: 'We’ve expanded to San Francisco, Miami, Houston, and Austin and have partnered with retailers and marketplaces like Rent The Runway, Mercari and more.',
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "You can order anything online with just a few clicks, yet returns are anything but easy. Every year, hundreds of millions of dollars worth of consumer goods lay dormant in people\u2019s homes because buyers weren\u2019t able to return their items on time, or it was simply too much of a hassle to. The outdated returns system is a problem - to the detriment of  both consumers and brands.",
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "During the COVID-19 pandemic, we\u2019ve seen consumer expectations around online shopping as we were forced to make that our primary form of commerce. Retailers have responded by making the buying process easier. Yet we have heard consistently that the returns process is clearly not catching up to the seamless shopping experience consumers now expect.",
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "In fact, returns are the number one headache for retailers, but businesses also want to get it right because to put it pretty simply, it\u2019s better for business. Retailers not only lose out on repeat customers when they aren't happy with the returns experience, they also have to spend more to staff customer service teams to handle the influx of returns requests.\n              ",
                                            },
                                            {
                                                type: 'IMAGE',
                                                data: '/assets/images/pickupImg.jpg',
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "We\u2019re completely changing how both businesses and consumers view returns, one seamless pick-up at a time. With next day pick-ups dispatched in 30 minute windows, a platform that enables live customer support along the way, and real time tracking, returns can be done without ever leaving your home - no printing labels, no waiting in line, and no reaching for the roll of tape.",
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "Today, we\u2019re excited to announce that we\u2019ve expanded outside of our home city of Los Angeles to San Francisco, Miami, Houston, and Austin and we\u2019ve raised $5 million in new funding led by LightShed Ventures to help fuel our expansion.\n              ",
                                            },
                                            {
                                                type: 'QUOTE',
                                                data: "\u201CWe\u2019ve expanded to San Francisco, Miami, Houston, and Austin and have partnered with retailers and marketplaces like Rent The Runway, Mercari and more.\u201D",
                                                options: {
                                                    italic: true,
                                                },
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "We\u2019re also pumped to welcome Good Friends (founders of Allbirds, Warby Parker and Harry\u2019s), Chris Homer (thredUP Co-Founder and COO), and V1.VC to our growing list of backers, which includes Graph Ventures and angel investors from companies like Uber, Instacart, Dropbox, Slack, Facebook, and more.",
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "The more comfort people have with returns, the more they shop.",
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "According to a recent consumer report, 80 percent of people surveyed always check shipping and return policies before they complete a purchase and 50 percent said these policies often determine whether or not they buy an item. ",
                                            },
                                            {
                                                type: 'IMAGE',
                                                data: '/assets/images/mainArticleImg.jpg',
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "The data clearly supports our case for building a customer-centric returns and first-mile pickup service and that\u2019s why businesses like Rent The Runway, and other large retailers are working alongside us to change the consumer experience by offering as early as next-day pickups to their customers.",
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "We also partner with online marketplaces like Mercari to provide a white-glove shipping experience for sellers. Our next-day pickup service significantly reduces the friction surrounding the shipping process. Sellers can simply choose their preferred date and we\u2019ll pick up, package, and ship the items for them.",
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "By providing a platform that enables next-day batched routes, we reduce the number of people driving to and from the post office, FedEx / UPS stores, etc. And by consolidating returns for brands (i.e. putting more returns in fewer boxes) we create a more efficient and sustainable supply chain. This dramatically reduces the number of boxes in circulation and drives significant return shipping savings for brands.",
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "To date, we\u2019ve returned more than 10 million dollars worth of returns to retailers, and garnered a 99 percent customer satisfaction score by delighting thousands of customers along the way with the Returnmates platform. We\u2019ve also seen up to 74 percent month over month growth in the past few months as we continue to ramp up our operations. ",
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "Moving forward, we\u2019re excited about expanding to even more US cities (we have ambitious plans!), adding more drivers to the platform, growing our internal engineering and product teams, partnering with more retailers, and continuing to create a universal returns experience enabling us to potentially offer unique features like one click returns, real time tracking, instant refunds, and more.",
                                            },
                                            {
                                                type: 'COMMON',
                                                data: "We\u2019re just getting started - more soon! ",
                                                options: {
                                                    bold: true,
                                                },
                                            },
                                        ],
                                    },
                                ],
                                pagination: {
                                    size: 6,
                                    page: 1,
                                    total: 1,
                                },
                            },
                        },
                    }];
            });
        }); };
        var publicLink = ApolloLink.from([
            createAuthLink({
                url: this.testsEnabled ? '' : this.config.aws.graphqlEndpoint,
                region: this.config.aws.region,
                auth: {
                    type: 'API_KEY',
                    apiKey: this.testsEnabled ? '' : this.config.aws.apiKey,
                },
            }),
            this.httpLink,
        ]);
        var publicPartnerLink = ApolloLink.from([
            createAuthLink({
                url: this.testsEnabled ? '' : this.config.aws.graphqlPartnerEndpoint,
                region: this.config.aws.region,
                auth: {
                    type: 'API_KEY',
                    apiKey: this.testsEnabled ? '' : this.config.aws.partnerApiKey,
                },
            }),
            this.partnerHttpLink,
        ]);
        var publicNotificationsLink = ApolloLink.from([
            createAuthLink({
                url: this.testsEnabled ? '' : this.config.aws.graphqlNotificationsEndpoint,
                region: this.config.aws.region,
                auth: {
                    type: 'API_KEY',
                    apiKey: this.testsEnabled ? '' : this.config.aws.notificationsApiKey,
                },
            }),
            this.notificationsHttpLink,
        ]);
        var subscriptionLink = ApolloLink.from([
            createAuthLink({
                url: this.testsEnabled ? '' : this.config.aws.graphqlEndpoint,
                region: this.config.aws.region,
                auth: {
                    type: 'API_KEY',
                    apiKey: this.testsEnabled ? '' : this.config.aws.apiKey,
                },
            }),
            createSubscriptionHandshakeLink({
                url: this.testsEnabled ? '' : this.config.aws.graphqlEndpoint,
                region: this.config.aws.region,
                auth: {
                    type: 'API_KEY',
                    apiKey: this.testsEnabled ? '' : this.config.aws.apiKey,
                },
            }),
        ]);
        var partnerSubscriptionLink = ApolloLink.from([
            createAuthLink({
                url: this.testsEnabled ? '' : this.config.aws.graphqlPartnerEndpoint,
                region: this.config.aws.region,
                auth: {
                    type: 'API_KEY',
                    apiKey: this.testsEnabled ? '' : this.config.aws.partnerApiKey,
                },
            }),
            createSubscriptionHandshakeLink({
                url: this.testsEnabled ? '' : this.config.aws.graphqlPartnerEndpoint,
                region: this.config.aws.region,
                auth: {
                    type: 'API_KEY',
                    apiKey: this.testsEnabled ? '' : this.config.aws.partnerApiKey,
                },
            }),
        ]);
        var notificationsSubscriptionLink = ApolloLink.from([
            createAuthLink({
                url: this.testsEnabled ? '' : this.config.aws.graphqlNotificationsEndpoint,
                region: this.config.aws.region,
                auth: {
                    type: 'API_KEY',
                    apiKey: this.testsEnabled ? '' : this.config.aws.notificationsApiKey,
                },
            }),
            createSubscriptionHandshakeLink({
                url: this.testsEnabled ? '' : this.config.aws.graphqlNotificationsEndpoint,
                region: this.config.aws.region,
                auth: {
                    type: 'API_KEY',
                    apiKey: this.testsEnabled ? '' : this.config.aws.notificationsApiKey,
                },
            }),
        ]);
        this.clientPublic = this.testsEnabled
            ? {
                query: function () { return null; },
                mutate: function () { return null; },
            } // eslint-disable-line
            : new ApolloClient({
                link: publicLink,
                cache: new InMemoryCache(),
                credentials: 'includes',
            });
        this.clientPartnerPublic = this.testsEnabled
            ? {
                query: function () { return null; },
                mutate: function () { return null; },
            } // eslint-disable-line
            : new ApolloClient({
                link: publicPartnerLink,
                cache: new InMemoryCache(),
                credentials: 'includes',
            });
        this.clientNotificationsPublic = this.testsEnabled
            ? {
                query: function () { return null; },
                mutate: function () { return null; },
            } // eslint-disable-line
            : new ApolloClient({
                link: publicNotificationsLink,
                cache: new InMemoryCache(),
                credentials: 'includes',
            });
        this.subscriptionClientPublic = new ApolloClient({
            link: subscriptionLink,
            cache: new InMemoryCache({ addTypename: false }),
        });
        this.partnerSubscriptionClient = new ApolloClient({
            link: partnerSubscriptionLink,
            cache: new InMemoryCache({ addTypename: false }),
        });
        this.notificationsSubscriptionClient = new ApolloClient({
            link: notificationsSubscriptionLink,
            cache: new InMemoryCache({ addTypename: false }),
        });
        this.createPrivateLink();
    }
    return CallApi;
}());
export default new CallApi();
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67, templateObject_68, templateObject_69, templateObject_70, templateObject_71, templateObject_72, templateObject_73, templateObject_74, templateObject_75, templateObject_76, templateObject_77, templateObject_78, templateObject_79, templateObject_80, templateObject_81, templateObject_82, templateObject_83, templateObject_84, templateObject_85, templateObject_86, templateObject_87, templateObject_88, templateObject_89, templateObject_90, templateObject_91, templateObject_92, templateObject_93, templateObject_94, templateObject_95, templateObject_96, templateObject_97, templateObject_98, templateObject_99, templateObject_100, templateObject_101, templateObject_102, templateObject_103, templateObject_104, templateObject_105, templateObject_106, templateObject_107, templateObject_108, templateObject_109, templateObject_110, templateObject_111, templateObject_112, templateObject_113, templateObject_114, templateObject_115, templateObject_116, templateObject_117, templateObject_118, templateObject_119, templateObject_120, templateObject_121, templateObject_122, templateObject_123, templateObject_124, templateObject_125, templateObject_126, templateObject_127, templateObject_128, templateObject_129, templateObject_130, templateObject_131, templateObject_132, templateObject_133, templateObject_134, templateObject_135, templateObject_136, templateObject_137, templateObject_138, templateObject_139, templateObject_140, templateObject_141, templateObject_142, templateObject_143, templateObject_144, templateObject_145, templateObject_146, templateObject_147, templateObject_148, templateObject_149, templateObject_150, templateObject_151, templateObject_152, templateObject_153, templateObject_154, templateObject_155, templateObject_156, templateObject_157, templateObject_158, templateObject_159, templateObject_160, templateObject_161, templateObject_162, templateObject_163, templateObject_164, templateObject_165, templateObject_166, templateObject_167, templateObject_168, templateObject_169, templateObject_170, templateObject_171, templateObject_172, templateObject_173;
//# sourceMappingURL=callApi.js.map